export default __webpack_public_path__ + "b782963841705c1411733ab09c4ac03b.png";